import BaseReportController from '../baseReportController';
import { filter as _filter } from 'lodash';

class MarketingConsentController extends BaseReportController {
  constructor(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, $ngConfirm, utilsService) {
    "ngInject";

    super(reportingService, loadingService, utilsService);

    if(!authService.validateUser(false, 'Reports', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.reportingService = reportingService;
    this.userService = userService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.$q = $q;
    this.$scope = $scope;
    this.printService = printService;
    this.exportService = exportService;
    this.$ngConfirm = $ngConfirm;
    this.utilsService = utilsService;

    this.reportCriteria = {};
    this.dtPopups = {};
    this.errMsgs = [];

    this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    this.summary = [];

    this.initializeLookups()
      .then(() => {
        this.getUserLocations();
        this.getDateRangeList();
        this.getVehicleConditionList();
        this.getEnquiryStatusList();
        this.getEnquiryOriginationList();
        this.getGdprCategoryList();
        this.getGdprChannelList();
        this.reset();
      });
  }

  initializeLookups() {
    const ctrl = this;
    const deferred = ctrl.$q.defer();

    this.lookupService.lookupBrands()
      .then(brands => {
        brands.splice(0, 1);
        brands.unshift({id: null, name: 'All'});
        this.brands = brands;

        this.lookupService.lookupBrandModels()
          .then(brandModels => {
            this.allBrandModels = brandModels;
            deferred.resolve();
          });
      });

      return deferred.promise;
  }

  updateBrandModel() {
    this.brandModels = _filter(this.allBrandModels, o => o.brandId === this.reportCriteria.brand.brandId);
    this.brandModels.unshift({id: null, name: 'All'});
    this.reportCriteria.brandModel = this.brandModels[0];
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  getVehicleConditionList() {
    this.vehicleConditionList = this.convertEnumToKeyValueList(this.enums.VEHICLE_CONDITION);
    this.vehicleConditionList.unshift({id:null, name: 'All'});
  }

  getEnquiryStatusList() {
    this.enquiryStatusList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_STATE);
    this.enquiryStatusList.unshift({id:null, name: 'All'});
  }

  getDateRangeList() {
    this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
  }
  
  getEnquiryOriginationList() {
    this.enquiryOriginationList = this.convertEnumToKeyValueList(this.enums.ENQUIRY_ORIGINATION);
    this.enquiryOriginationList.unshift({id:null, name: 'All'});
  }

  getGdprCategoryList() {
    this.gdprCategoryList = [];
    this.gdprCategoryList.push({id:null, name: 'Please Select'});
    this.gdprCategoryList.push({id:'marketing', name: 'Marketing'});
    this.gdprCategoryList.push({id:'service', name: 'Service'});
    this.gdprCategoryList.push({id:'manufacturer', name: 'Manufacturer'});
    this.gdprCategoryList.push({id:'surveys', name: 'Surveys'});
    this.gdprCategoryList.push({id:'changeCycle', name: 'Change Cycle'});
  }  

  getGdprChannelList() {
    this.gdprChannelList = [];
    this.gdprChannelList.push({id:null, name: 'Please Select'});
    this.gdprChannelList.push({id:'email', name: 'Email'});
    this.gdprChannelList.push({id:'text', name: 'Text'});
    this.gdprChannelList.push({id:'phone', name: 'Phone'});
    this.gdprChannelList.push({id:'post', name: 'Post'});
  }    

  showDatePopup(fieldName) {
    this.dtPopups[fieldName] = true;
  }

  reset() {
    this.$scope.$broadcast('reports:reset');
    
    this.summary = [];

    this.errMsgs = [];

    this.reportCriteria.dateRangeOption = this.dateRangeList[0];
    this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
    this.reportCriteria.startDate = new Date();
    this.reportCriteria.endDate = new Date();
    this.reportCriteria.location = this.userLocations[0];
    this.reportCriteria.brand = this.brands[0];
    this.reportCriteria.enquiryStatus = this.enquiryStatusList[0];
    this.reportCriteria.enquiryOrigination = this.enquiryOriginationList[0];
    this.reportCriteria.gdprCategory = this.gdprCategoryList[0];
    this.reportCriteria.gdprChannel = this.gdprChannelList[0];

    this.updateUserList();
    this.updateBrandModel();
  }

  updateUserList() {
    this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');

    this.userService.getEntityUsers(this.getLocationIds())
      .then((response) => {
        this.userList = response.data.map((i) => {return {id: i.userId, name: i.firstName + ' ' + i.lastName};});
        this.userList.unshift({id: null, name: 'All'});

        this.reportCriteria.user = this.userList[0];
      })
      .finally(() => {
        this.loadingService.hideLoading('reportCriteria');
      });
  }
  
  runReport() {
    this.panels.reportData = true;

    this.$scope.$broadcast('reports:runReport', {
      action: 'marketingConsent',
      criteriaValidator: this.validateCriteria.bind(this), 
      criteriaParser: this.parseCriteria.bind(this)
    });
  }  

  validateCriteria() {
    this.errMsgs = [];

    if (!this.reportCriteria.startDate) {
      this.errMsgs.push('Please provide a Start Date');
    }

    if (!this.reportCriteria.endDate) {
      this.errMsgs.push('Please provide an End Date');
    }

    if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
      this.errMsgs.push('Start Date can not be greater than End Date');
    }

    if (this.reportCriteria.gdprCategory.id === null) {
      this.errMsgs.push('Please select a Category first');
    }    

    if (this.reportCriteria.gdprChannel.id === null) {
      this.errMsgs.push('Please select a Channel first');
    }        

    return this.errMsgs.length === 0;
  }

  parseCriteria() {
    let parsedCriteria = {};

    this.parseStartAndEndDate(parsedCriteria);
    
    parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
    parsedCriteria.locationIds = this.getLocationIds();
    parsedCriteria.salesRepId = this.reportCriteria.user.id;
    parsedCriteria.brandId = this.reportCriteria.brand.brandId;
    parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;
    parsedCriteria.enquiryStatus = this.reportCriteria.enquiryStatus.id;
    parsedCriteria.enquiryOrigination = this.reportCriteria.enquiryOrigination.id;
    parsedCriteria.gdprCategory = this.reportCriteria.gdprCategory.id;
    parsedCriteria.gdprChannel = this.reportCriteria.gdprChannel.id;

    return parsedCriteria;
  }

  getLocationIds() {
    let locationIds;

    if (!this.reportCriteria.location.id) {
      locationIds = _filter(this.userLocations, o => o.id).map(ul => ul.id);
    }
    else {
      locationIds = [this.reportCriteria.location.id];
    }

    return locationIds;
  }

  onReportRun(summary){
    this.summary = summary;
  }  

  printReport(){
    if (!this.validateCriteria()) {
      return;
    }

    this.printService.printReport('Marketing Consent', this.parseCriteria());
  }  

  exportReport() {
    if (!this.validateCriteria()) {
      return;
    }

    this.$ngConfirm({
      title: `Export Contact Information`,
      content: `<b>Exporting contact information will update the contact life cycle for impacted contacts</b>`,
      typeAnimation: false,
      columnClass: 'm',
      buttons: {
        yes1: {
              text: 'Export',
              btnClass: 'btn-primary',
              action: () => { 
                const criteria = this.parseCriteria();
                criteria.additionalParameter1 = "true";
                criteria.additionalParameter2 = this.authService.authData.userId;
                this.exportService.exportReport('Marketing Consent', criteria);                
              }
        },  
        yes2: {
          text: 'Export with Promise',
          btnClass: 'btn-default',
          action: () => { this.exportReportWithPromise(); }
        },                
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });    
  }    

  exportReportWithPromise() {
    const criteria = this.parseCriteria();

    const scope = this.$scope.$new();

    scope.dueDate = null;

    scope.datePickerOptions = {
      minDate: new Date(),
      showButtonBar: false
    };    

    this.$ngConfirm({
      title: `Export Contact Information`,
      contentUrl: `templates/reports/marketingConsentExportTemplate`,
      typeAnimation: false,
      columnClass: 'l',
      scope: scope,
      buttons: {
        yes: {
              text: 'Export',
              btnClass: 'btn-primary',
              action: (scope) => {  
                //Validation
                if (!scope.subject || !scope.dueDate || !scope.dueTime) {
                  scope.errMsg = "Please fill in all the fields to proceed";

                  return false;
                }

                const criteria = this.parseCriteria();
                criteria.additionalParameter1 = "true";
                criteria.additionalParameter2 = this.authService.authData.userId;
                criteria.additionalParameter3 = this.authService.authData.currentLocation.key;
                criteria.additionalParameter4 = scope.subject;
                criteria.additionalParameter5 = this.getFullDateTime(scope.dueDate, scope.dueTime);
                
                this.exportService.exportReport('Marketing Consent', criteria);                                
              }
        },        
        no: {
          text: 'Cancel',
          btnClass: 'btn-default'
        }          
    }
    });  
  }  
  
  getFullDateTime(dueDate, dueTime) {
    const dt = `${dueDate.getFullYear()}-${(dueDate.getMonth() + 1)}-${dueDate.getDate()}`;
    const time = `${dueTime.getHours()}:${(dueTime.getMinutes())}`;

    return `${dt} ${time}`
  }
}

export default MarketingConsentController;


// WEBPACK FOOTER //
// ./client/app/components/reports/marketingConsent/marketingConsent.controller.js